import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./css/quizCompleted.css";
import CelebrationBomb from "./CelebrationBomb";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getConfirmacionStatusThunk } from "../../../store/confirmacion/confirmacion.thunks";

const QuizCompleted = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, statusLoading } = useSelector((state) => state.confirmacion);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const loadStatus = async () => {
      try {
        await dispatch(getConfirmacionStatusThunk()).unwrap();
      } catch (error) {
        // Las confirmaciones aún no están disponibles
      }
    };
    loadStatus();
  }, [dispatch]);

  useEffect(() => {
    // Mostrar botón después de la animación de celebración
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleConfirmacion = () => {
    navigate("/confirmacion-talentos");
  };

  const handleVerTalentos = () => {
    navigate("/mis-talentos");
  };

  const todasCompletadas = status?.todas_completadas;
  const buttonText = "Sigamos construyendo tus 7 fortalezas únicas";
  const verTalentosText = "Ya puedes ver tus 5 poderosos talentos";

  return (
    <div className="quiz-completed-wrapper">
      <CelebrationBomb
        message="¡Evaluación completada!"
        intensity={120}
        duration={4}
        size="lg"
      />

      <motion.div
        className="quiz-completed-card"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="quiz-completed-icon-wrapper"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.4, type: "spring" }}
        >
          <Icon icon="ph:check-bold" />
        </motion.div>

        <motion.h2
          className="quiz-completed-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          ¡Quiz completado!
        </motion.h2>

        <motion.p
          className="quiz-completed-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          Ya puedes ver tus talentos principales
        </motion.p>

        {showButton && !statusLoading && !todasCompletadas && (
          <motion.button
            className="quiz-completed-btn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1 }}
            onClick={handleConfirmacion}
          >
            <Icon icon="mdi:star-check" />
            <span>{buttonText}</span>
          </motion.button>
        )}

        {showButton && (
          <motion.button
            className="quiz-completed-btn quiz-completed-btn--secondary"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15 }}
            onClick={handleVerTalentos}
          >
            <Icon icon="mdi:eye-outline" />
            <span>{verTalentosText}</span>
          </motion.button>
        )}

        {showButton && todasCompletadas && (
          <motion.p
            className="quiz-completed-info"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.3 }}
          >
            <Icon icon="mdi:check-all" />
            Has completado todas las confirmaciones
          </motion.p>
        )}
      </motion.div>
    </div>
  );
};

export default QuizCompleted;
